import React, { useState, useEffect } from "react";
import { Dropdown, Form, Grid, Input } from "semantic-ui-react";
import BCAddressForm from "../ui/BCAddressForm";
import BCMessage from "../ui/BCMessage";
import { getBorrowers, getContacts } from "../../api/LOApi";
import { getMockBorrowers, getMockContacts } from "../../api/mock/MockLOApi";
import { getDropdownOptions } from "../../Helpers";
import { FeatureFlags } from "../constants/LocalServerConstants";

const LODealForm = ({ deals, newDeal, setNewDeal, handleAddBorrower, handleAddContact }) => {
  const [isApiMessage, setIsApiMessage] = useState(false);
  const [borrowers, setBorrowers] = useState(undefined as any);
  const [contacts, setContacts] = useState(undefined as any);

  const handleFormChange = (value, field) => {
    newDeal[field] = value;
    setNewDeal(newDeal);
  };

  useEffect(() => {
    const getBorrowersAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockBorrowers() : await getBorrowers();
        if (response && response.ok) {
          setIsApiMessage(false);
          setBorrowers(await response.json());
        }
        else {
          FeatureFlags.IS_DEBUG && console.log(response);
          setIsApiMessage(true);
        }
      }
      catch (error) {
        FeatureFlags.IS_DEBUG && console.log(error);
        setIsApiMessage(false);
      }
    };

    const getContactsAsync = async () => {
      try {
        const response = FeatureFlags.IS_MOCK ? await getMockContacts() : await getContacts();
        if (response && response.ok) {
          setIsApiMessage(false);
          setContacts(await response.json());
        }
        else {
          FeatureFlags.IS_DEBUG && console.log(response);
          setIsApiMessage(true);
        }
      }
      catch (error) {
        FeatureFlags.IS_DEBUG && console.log(error);
        setIsApiMessage(false);
      }
    };

    getBorrowersAsync();
    getContactsAsync();
  }, []);
  
  return (
    <div>
      <BCMessage
        animation={"fade down"}
        duration={500}
        visible={isApiMessage}
        transitionOnMount
        styles="full-width"
        negative
        color="red"
        onDismiss={() => setIsApiMessage(false)}
        header={"Oops!"}
        text={"It looks like something went wrong."}
      />
      <Form className="">
        <Grid className="">
          <Grid.Row>
            <Grid.Column width={16}>
              <Form.Field className="">
                <label>
                  <span>Borrower Name: </span>
                  <span className="deal-dropdown-add" onClick={handleAddBorrower}>+ Add New Borrower</span>
                </label>
                <Dropdown
                  placeholder="Loan Construction Services II, LLC"
                  fluid
                  search
                  selection
                  options={borrowers ? getDropdownOptions(borrowers, ["name"]) : []}
                  onChange={(e, { value }) => handleFormChange(value, "borrowersName")}
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column width={16}>
              <Form.Field className="">
                <label>
                  <span>Contact Person: </span>
                  <span className="deal-dropdown-add" onClick={handleAddContact}>+ Add New Contact</span>
                </label>
                <Dropdown
                  placeholder="John Smith"
                  fluid
                  search
                  selection
                  options={contacts ? getDropdownOptions(contacts, ["firstName", "lastName"]) : []}
                  onChange={(e, { value }) => handleFormChange(value, "contactPerson")}
                />
              </Form.Field>
            </Grid.Column>
            <BCAddressForm handleFormChange={handleFormChange} />
            <Grid.Column width={8}>
              <Form.Field className="">
                <label>Loan Amount: </label>
                <Input 
                  placeholder="10000" 
                  onChange={(e) => handleFormChange(e.target.value, "loanAmount")}
                  type="number"
                  fluid
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column width={8}>
              <Form.Field className="">
                <label>Deal Status: </label>
                <Dropdown
                  placeholder="Lead"
                  fluid
                  search
                  selection
                  options={deals ? getDropdownOptions(deals, ["name"]) : []}
                  onChange={(e, { value }) => handleFormChange(value, "dealStatus")}
                />
              </Form.Field>
            </Grid.Column>
            <Grid.Column width={16}>
              <Form.Field className="">
                <label>Expected Close Date: </label>
                <Input 
                  placeholder="1/1/2020" 
                  onChange={(e) => handleFormChange(e.target.value, "closeDate")}
                  type="text"
                  fluid 
                />
              </Form.Field>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    </div>
  );
};

export default LODealForm;